import { ReactSelect } from './styles'

export default ReactSelect
